/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Import in progress" |
*
* @param {Load_Project_File_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_progress_label = /** @type {((inputs?: Load_Project_File_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation en cours")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import läuft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione in corso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт в процессе")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación en curso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入进行中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポート中")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात जारी है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação em andamento")
	return /** @type {LocalizedString} */ ("Import in progress")
});